var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentDesigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6441_460031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.30435 0H0V7.30435H7.30435V0Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6522 0H8.34783V7.30435H12.5217L15.6522 4.17391V0Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6957 11.4783L19.8261 8.34783H24V15.6522H16.6957V11.4783Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4783 8.34783H8.34783V11.4783L11.4783 8.34783Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5217 15.6522L15.6522 12.5217V15.6522H12.5217Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34783 19.8261L11.4783 16.6957H15.6522V24H8.34783V19.8261Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13043 16.6957L1.04348 22.9565L7.30435 20.8696V24H0V16.6957H3.13043Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30435 12.5217L4.17391 15.6522H0V8.34783H7.30435V12.5217Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8696 7.30435L24 4.17391V7.30435H20.8696Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8261 0L16.6957 3.13043V0H19.8261Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8261 0L24 4.17391V0H19.8261Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6957 16.6957H24V24H16.6957V16.6957Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8261 6.78261L17.2174 4.17391L5.21739 16.1739L7.82609 18.7826L19.8261 6.78261Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2609 3.13043L19.8261 1.56522L22.4348 4.17391L20.8696 5.73913L18.2609 3.13043Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78261 19.8261L4.17391 17.2174L3.13043 19.8261L4.17391 20.8696L6.78261 19.8261Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19406 16.7713L2.36233 21.6571L7.33697 19.8931L4.19406 16.7713ZM6.86876 18.9281L7.66256 19.7165L21.1619 6.12589L20.3681 5.33743L6.86876 18.9281ZM18.1233 2.60772L21.4119 5.87421L22.9118 4.36414L19.6232 1.09764L18.1233 2.60772ZM18.6671 3.64786L17.8733 2.85939L4.37396 16.4501L5.16776 17.2385L18.6671 3.64786ZM18.8939 3.87313L5.39456 17.4638L6.64196 18.7028L20.1413 5.11215L18.8939 3.87313Z",
    fill: "#F7A246"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86871 18.928L7.66251 19.7164L21.1618 6.12578L20.368 5.33732L6.86871 18.928Z",
    fill: "#CE873A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.667 3.64775L17.8732 2.85929L4.37384 16.45L5.16764 17.2384L18.667 3.64775Z",
    fill: "#F8B165"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81115 22.1989L7.73309 20.0991L23.3885 4.33766L19.6464 0.620615L3.99263 16.3803L1.81115 22.1989ZM2.36231 21.657L4.19403 16.7713L7.33694 19.8931L2.36231 21.657ZM7.66253 19.7165L6.86873 18.928L20.3681 5.33735L21.1619 6.12582L7.66253 19.7165ZM21.4118 5.87414L18.1232 2.60764L19.6232 1.09757L22.9118 4.36406L21.4118 5.87414ZM17.8733 2.85932L18.6671 3.64779L5.16773 17.2384L4.37393 16.45L17.8733 2.85932ZM5.39453 17.4637L18.8939 3.87306L20.1413 5.11208L6.64193 18.7027L5.39453 17.4637Z",
    fill: "#7B5123"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6441_460031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentDesigned);
export default __webpack_public_path__ + "static/media/Experiment_Designed.e3de22841a72a07b08f584dface10d3c.svg";
export { ForwardRef as ReactComponent };